import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable()
export class GroupsService {

  constructor(
    private http: Http
  ) { }

  getAll() {
    return this.http
      .get(`${environment.apiUrl}/admin/groups`)
      .map(this.extractData);
  }

  delete(groupId: number): Observable<Response> {
    return this.http.delete(`${environment.apiUrl}/admin/groups/${groupId}`);
  }

  save(groupName: string) {
    return this.http
      .post(`${environment.apiUrl}/admin/groups`, {
        name: groupName
      })
      .map(this.extractData);
  }


  private extractData(res: Response) {
    let body = res.json();
    return body || [];
  }
}



// WEBPACK FOOTER //
// ./src/app/services/groups.service.ts